import { Emoji } from './Emoji';
export const EmojiPluginID = 'emoji';
export const emojiPlugin = {
    id: EmojiPluginID,
    component: Emoji
};
